module.exports = __webpack_public_path__ + "img/google_login_logo.a1e1d654.png";